import api from './core/api';
import { ApiResponse } from './core/AbstractService';

export interface ShippingConfig {
  kosovoShippingCost: number;
  albaniaShippingCost: number;
  northMacedoniaShippingCost: number;
  kosovoFreeThreshold: number;
  albaniaFreeThreshold: number;
  northMacedoniaFreeThreshold: number;
}

class ConfigService {
  private basePath = '/configs';

  async getShippingConfig(): Promise<ApiResponse<ShippingConfig>> {
    const response = await api.get<ApiResponse<ShippingConfig>>(
      `${this.basePath}/shipping`
    );
    return response.data;
  }

  async updateShippingConfig(
    data: Partial<ShippingConfig>
  ): Promise<void> {
    // The backend uses individual config keys, so we update each one
    const keyMap: Record<keyof ShippingConfig, string> = {
      kosovoShippingCost: 'shipping.kosovo_cost',
      albaniaShippingCost: 'shipping.albania_cost',
      northMacedoniaShippingCost: 'shipping.north_macedonia_cost',
      kosovoFreeThreshold: 'shipping.kosovo_free_threshold',
      albaniaFreeThreshold: 'shipping.albania_free_threshold',
      northMacedoniaFreeThreshold: 'shipping.north_macedonia_free_threshold',
    };

    const updates = Object.entries(data).map(([key, value]) => {
      const configKey = keyMap[key as keyof ShippingConfig];
      return api.put(`${this.basePath}/${configKey}`, {
        value: String(value),
        type: 'number',
      });
    });

    await Promise.all(updates);
  }

  async initializeShippingConfig(): Promise<ApiResponse<ShippingConfig>> {
    const response = await api.post<ApiResponse<ShippingConfig>>(
      `${this.basePath}/shipping/initialize`
    );
    return response.data;
  }
}

export const configService = new ConfigService();
